<form class="space-y-6" (ngSubmit)="onSubmit()" #form="ngForm">
  <!-- Error Alert -->
  @if (error()) {
  <div class="animate-slideInUp">
    <lib-error-alert [error]="error()" />
  </div>
  }

  <!-- Success Message -->
  @if (successMessage()) {
  <div class="animate-slideInUp">
    <sb-success-alert [message]="successMessage()" />
  </div>
  }

  <div class="space-y-4">
    <!-- Current Password -->
    <div class="animate-slideInLeft" style="animation-delay: 100ms">
      <sb-text-input
        id="current_password"
        name="current_password"
        label="Current Password"
        type="password"
        [required]="true"
        [(ngModel)]="formData().current_password"
        [errorMessage]="formErrors()['current_password'] || ''"
        (inputBlur)="validateField('current_password')"
        (ngModelChange)="updateFormField('current_password', $event)"
      />
    </div>

    <!-- New Password -->
    <div class="animate-slideInLeft" style="animation-delay: 200ms">
      <sb-text-input
        id="new_password"
        name="new_password"
        label="New Password"
        type="password"
        [required]="true"
        [(ngModel)]="formData().new_password"
        [errorMessage]="formErrors()['new_password'] || ''"
        (inputBlur)="validateField('new_password')"
        (ngModelChange)="updateFormField('new_password', $event)"
        helpText="Password must be at least 8 characters long"
      />
    </div>

    <!-- Confirm New Password -->
    <div class="animate-slideInLeft" style="animation-delay: 300ms">
      <sb-text-input
        id="confirm_password"
        name="confirm_password"
        label="Confirm New Password"
        type="password"
        [required]="true"
        [(ngModel)]="formData().confirm_password"
        [errorMessage]="formErrors()['confirm_password'] || ''"
        (inputBlur)="validateField('confirm_password')"
        (ngModelChange)="updateFormField('confirm_password', $event)"
      />
    </div>
  </div>

  <!-- Password Requirements -->
  <div class="animate-slideInUp" style="animation-delay: 400ms">
    <div class="bg-blue-50 border border-blue-200 rounded-md p-4">
      <h4 class="text-sm font-medium text-blue-900 mb-2">
        Password Requirements:
      </h4>
      <ul class="text-sm text-blue-700 space-y-1">
        <li class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          At least 8 characters long
        </li>
        <li class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          Different from your current password
        </li>
        <li class="flex items-center">
          <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          Both new password fields must match
        </li>
      </ul>
    </div>
  </div>

  <!-- Form Actions -->
  <div
    class="flex flex-col sm:flex-row gap-3 animate-slideInUp sm:justify-end"
    style="animation-delay: 500ms"
  >
    <shared-submit-button
      buttonText="Change Password"
      loadingText="Changing Password..."
      [isLoading]="isLoading()"
      [disabled]="!isFormValid()"
      [fullWidth]="true"
      variant="primary"
      size="md"
    />

    <button
      type="button"
      (click)="resetForm()"
      [disabled]="isLoading()"
      class="flex-1 sm:flex-none px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
    >
      Reset
    </button>
  </div>

  <!-- Security Notice -->
  <div class="animate-slideInUp" style="animation-delay: 600ms">
    <div class="bg-yellow-50 border border-yellow-200 rounded-md p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg
            class="h-5 w-5 text-yellow-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-yellow-800">Security Notice</h3>
          <div class="mt-2 text-sm text-yellow-700">
            <p>
              Changing your password will log you out of all other devices for
              security reasons. You'll need to log in again on those devices.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
